import BRANDING from './brandingConst';

export default {
    // ========================================================
    //  Web - Typography
    // ========================================================
    [BRANDING.GLOBAL_HEADING_FONT_FAMILY]: 'web.global.heading.fontFamily',
    [BRANDING.GLOBAL_BODY_FONT_FAMILY]: 'web.global.body.fontFamily',
    // ========================================================
    //  Web - Colors
    // ========================================================
    [BRANDING.GLOBAL_FONT_COLOR]: 'web.global.fontColor',
    [BRANDING.GLOBAL_LINK_COLOR]: 'web.global.linkColor',
    [BRANDING.GLOBAL_SUCCESS_COLOR]: 'web.global.successColor',
    [BRANDING.GLOBAL_WARNING_COLOR]: 'web.global.warningColor',
    [BRANDING.GLOBAL_ERROR_COLOR]: 'web.global.errorColor',
    [BRANDING.GLOBAL_INFO_COLOR]: 'web.global.infoColor',
    [BRANDING.GLOBAL_PRIMARY_COLOR]: 'web.global.primaryColor',
    [BRANDING.GLOBAL_SECONDARY_COLOR]: 'web.global.secondaryColor',
    [BRANDING.GLOBAL_TERTIARY_COLOR]: 'web.global.tertiaryColor',
    // ========================================================
    //  Web - Button - Shared
    // ========================================================
    [BRANDING.GLOBAL_BTN_BORDER_WIDTH]: 'web.global.button.borderWidth',
    [BRANDING.GLOBAL_BTN_BORDER_RADIUS]: 'web.global.button.borderRadius',
    // ========================================================
    //  Web - Primary Button
    // ========================================================
    [BRANDING.GLOBAL_PRIMARY_BTN_BG_COLOR_START]:
        'web.global.button.primary.bgColor.start',
    [BRANDING.GLOBAL_PRIMARY_BTN_BG_COLOR_END]:
        'web.global.button.primary.bgColor.end',
    [BRANDING.GLOBAL_PRIMARY_BTN_TEXT_COLOR]:
        'web.global.button.primary.textColor',
    [BRANDING.GLOBAL_PRIMARY_BTN_BORDER_COLOR]:
        'web.global.button.primary.borderColor',
    // ========================================================
    //  Web - Secondary Button
    // ========================================================
    [BRANDING.GLOBAL_SECONDARY_BTN_BG_COLOR_START]:
        'web.global.button.secondary.bgColor.start',
    [BRANDING.GLOBAL_SECONDARY_BTN_BG_COLOR_END]:
        'web.global.button.secondary.bgColor.end',
    [BRANDING.GLOBAL_SECONDARY_BTN_TEXT_COLOR]:
        'web.global.button.secondary.textColor',
    [BRANDING.GLOBAL_SECONDARY_BTN_BORDER_COLOR]:
        'web.global.button.secondary.borderColor',
    // ========================================================
    //  Web - Tertiary Button
    // ========================================================
    [BRANDING.GLOBAL_TERTIARY_BTN_BG_COLOR_START]:
        'web.global.button.tertiary.bgColor.start',
    [BRANDING.GLOBAL_TERTIARY_BTN_BG_COLOR_END]:
        'web.global.button.tertiary.bgColor.end',
    [BRANDING.GLOBAL_TERTIARY_BTN_TEXT_COLOR]:
        'web.global.button.tertiary.textColor',
    [BRANDING.GLOBAL_TERTIARY_BTN_BORDER_COLOR]:
        'web.global.button.tertiary.borderColor',
    // ========================================================
    //  Web - Destructive Primary Button
    // ========================================================
    [BRANDING.GLOBAL_PRIMARY_DESTRUCTIVE_BTN_BG_COLOR_START]:
        'web.global.button.primary.destructive.bgColor.start',
    [BRANDING.GLOBAL_PRIMARY_DESTRUCTIVE_BTN_BG_COLOR_END]:
        'web.global.button.primary.destructive.bgColor.end',
    [BRANDING.GLOBAL_PRIMARY_DESTRUCTIVE_BTN_TEXT_COLOR]:
        'web.global.button.primary.destructive.textColor',
    [BRANDING.GLOBAL_PRIMARY_DESTRUCTIVE_BTN_BORDER_COLOR]:
        'web.global.button.primary.destructive.borderColor',
    // ========================================================
    //  Web - Destructive Secondary Button
    // ========================================================
    [BRANDING.GLOBAL_SECONDARY_DESTRUCTIVE_BTN_BG_COLOR_START]:
        'web.global.button.secondary.destructive.bgColor.start',
    [BRANDING.GLOBAL_SECONDARY_DESTRUCTIVE_BTN_BG_COLOR_END]:
        'web.global.button.secondary.destructive.bgColor.end',
    [BRANDING.GLOBAL_SECONDARY_DESTRUCTIVE_BTN_TEXT_COLOR]:
        'web.global.button.secondary.destructive.textColor',
    [BRANDING.GLOBAL_SECONDARY_DESTRUCTIVE_BTN_BORDER_COLOR]:
        'web.global.button.secondary.destructive.borderColor',
    // ========================================================
    //  Web - Masthead
    // ========================================================
    [BRANDING.MASTHEAD_BG_COLOR_START]: 'web.masthead.bgColor.start',
    [BRANDING.MASTHEAD_BG_COLOR_END]: 'web.masthead.bgColor.end',
    [BRANDING.MASTHEAD_BG_IMG]: 'web.masthead.bgImage',
    [BRANDING.MASTHEAD_BG_IMG_FITS_TO_AREA]: 'web.masthead.bgImage.fitsToArea',
    [BRANDING.MASTHEAD_BG_IMG_POSITION]: 'web.masthead.bgImage.position',
    [BRANDING.MASTHEAD_BG_IMG_REPEAT]: 'web.masthead.bgImage.repeat',
    [BRANDING.MASTHEAD_BG_IMG_SIZE]: 'web.masthead.bgImage.size',
    [BRANDING.MASTHEAD_LOGO_LARGE]: 'web.masthead.logo.large',
    [BRANDING.MASTHEAD_LOGO_SMALL]: 'web.masthead.logo.small',
    [BRANDING.MASTHEAD_TEXT_COLOR]: 'web.masthead.textColor',
    // ========================================================
    //  Web - Main Navigation
    // ========================================================
    [BRANDING.MAIN_NAV_BG_COLOR]: 'web.mainNav.bgColor',
    [BRANDING.MAIN_NAV_TEXT_COLOR]: 'web.mainNav.textColor',
    [BRANDING.MAIN_NAV_SUB_NAV_BG_COLOR]: 'web.mainNav.subNav.bgColor',
    [BRANDING.MAIN_NAV_SUB_NAV_LINK_COLOR]: 'web.mainNav.subNav.linkColor',
    [BRANDING.MAIN_NAV_SUB_NAV_HEADING_COLOR]:
        'web.mainNav.subNav.headingColor',
    // ========================================================
    //  Web - Utility Navigation
    // ========================================================
    [BRANDING.UTILITY_NAV_BG_COLOR]: 'web.utilityNav.bgColor',
    [BRANDING.UTILITY_NAV_LINK_COLOR]: 'web.utilityNav.linkColor',
    // ========================================================
    //  Web - Featured Navigation
    // ========================================================
    [BRANDING.FEATURED_NAV_BG_COLOR]: 'web.featuredNav.bgColor',
    [BRANDING.FEATURED_NAV_LINK_COLOR]: 'web.featuredNav.linkColor',
    [BRANDING.FEATURED_NAV_FLAG_BG_COLOR]: 'web.featuredNav.flag.bgColor',
    [BRANDING.FEATURED_NAV_FLAG_TEXT_COLOR]: 'web.featuredNav.flag.textColor',
    // ========================================================
    // Web - Body
    // ========================================================
    [BRANDING.BODY_BG_COLOR_START]: 'web.body.bgColor.start',
    [BRANDING.BODY_BG_COLOR_END]: 'web.body.bgColor.end',
    [BRANDING.BODY_BG_IMG]: 'web.body.bgImage',
    [BRANDING.BODY_BG_IMG_FITS_TO_AREA]: 'web.body.bgImage.fitsToArea',
    [BRANDING.BODY_BG_IMG_REPEAT]: 'web.body.bgImage.repeat',
    [BRANDING.BODY_BG_IMG_POSITION]: 'web.body.bgImage.position',
    [BRANDING.BODY_BG_IMG_SIZE]: 'web.body.bgImage.size',
    [BRANDING.BODY_TEXT_COLOR]: 'web.body.textColor',
    // ========================================================
    //  Web - Widgets
    // ========================================================
    [BRANDING.WIDGETS_HEADER_BG_COLOR]: 'web.widgets.header.bgColor',
    [BRANDING.WIDGETS_HEADER_TEXT_COLOR]: 'web.widgets.header.textColor',
    [BRANDING.WIDGETS_BORDER_COLOR]: 'web.widgets.borderColor',
    [BRANDING.WIDGETS_BORDER_RADIUS]: 'web.widgets.borderRadius',
    [BRANDING.WIDGETS_BORDER_WIDTH]: 'web.widgets.borderWidth',
    [BRANDING.WIDGETS_BG_OPACITY]: 'web.widgets.bgOpacity',
    [BRANDING.WIDGETS_HAS_DROP_SHADOW]: 'web.widgets.hasDropShadow',
    [BRANDING.WIDGETS_DROP_SHADOW]: 'web.widgets.boxShadow',
    // ========================================================
    //  Footer
    // ========================================================
    [BRANDING.FOOTER_BG_COLOR_START]: 'web.footer.bgColor.start',
    [BRANDING.FOOTER_BG_COLOR_END]: 'web.footer.bgColor.end',
    [BRANDING.FOOTER_BG_IMG]: 'web.footer.bgImage',
    [BRANDING.FOOTER_BG_IMG_FITS_TO_AREA]: 'web.footer.bgImage.fitsToArea',
    [BRANDING.FOOTER_BG_IMG_REPEAT]: 'web.footer.bgImage.repeat',
    [BRANDING.FOOTER_BG_IMG_POSITION]: 'web.footer.bgImage.position',
    [BRANDING.FOOTER_LINK_COLOR]: 'web.footer.linkColor',
    [BRANDING.FOOTER_TEXT_COLOR]: 'web.footer.textColor',
};
